import { useAuth0 } from "@auth0/auth0-react";
import { Box, Button, Typography } from "@mui/material";
import { FC } from "react";

export const NoAccessPage: FC = () => {
  const { logout } = useAuth0();

  return (
    <Box
      data-test="crm-no-access"
      sx={{
        position: "absolute",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flexDirection: "column",
          textAlign: "center",
          maxWidth: "32rem",
          px: "1rem",
        }}
      >
        <Typography
          sx={{
            fontFamily: "h1.fontFamily",
            color: "secondary.main",
            fontWeight: 700,
            fontSize: "2rem",
          }}
        >
          No CRM access
        </Typography>
        <Typography>You are not assigned to any CRM clients.</Typography>
        <Typography sx={{ mt: "1rem" }}>
          If you believe you should have access, contact your administrator, then refresh this page.
        </Typography>
        <Button
          data-test="crm-no-access-signout"
          variant="contained"
          onClick={() => logout({ logoutParams: { returnTo: window.location.origin } })}
          sx={{ mt: "1.5rem" }}
        >
          Sign out
        </Button>
      </Box>
    </Box>
  );
};
